import { List, Map } from 'immutable'
import { IMenuItem } from 'hooks/useMenu'

const frItems: IMenuItem[] = [
  {
    title: 'Le Groupe',
    items: [
      {
        title: 'La révolution iliad',
        items: [],
        link: '/fr/le-groupe/la-revolution-iliad'
      },
      {
        title: 'Qui sommes-nous ?',
        items: [],
        link: '/fr/le-groupe/qui-sommes-nous'
      },
      {
        title: 'Vision',
        items: [],
        link: '/fr/le-groupe/vision'
      },
      {
        title: 'Devise',
        items: [],
        link: '/fr/le-groupe/devise'
      },
      {
        title: "25 ans d'innovation",
        items: [],
        link: '/fr/le-groupe/25-ans-innovation'
      },
      {
        title: 'Gouvernance',
        items: [],
        link: '/fr/le-groupe/gouvernance'
      },
      {
        title: 'Ethique et conformité',
        items: [],
        link: '/fr/le-groupe/ethique-et-conformite'
      }
    ]
  },
  {
    title: 'Engagements',
    items: [
      {
        title: 'Faire les choses bien',
        items: [],
        link: '/fr/nos-engagements/faire-les-choses-bien'
      },
      {
        title: 'Pour nos collaborateurs',
        items: [],
        link: '/fr/nos-engagements/pour-nos-collaborateurs'
      },
      {
        title: "Pour l'environnement",
        items: [],
        link: '/fr/nos-engagements/pour-l-environnement'
      },
      {
        title: 'Pour la société',
        items: [],
        link: '/fr/nos-engagements/pour-la-societe'
      },
      {
        title: 'Documents ESG',
        items: [],
        link: `/fr/nos-engagements/documents-esg/${new Date().getFullYear()}`
      }
    ]
  },
  {
    title: 'Réseaux',
    items: [
      {
        title: 'Chiffres-clés',
        items: [],
        link: '/fr/nos-reseaux/chiffres-cles'
      },
      {
        title: 'Présence en France',
        items: [],
        link: '/fr/nos-reseaux/presence-en-france'
      },
      {
        title: "Installation d'une antenne",
        items: [],
        link: '/fr/nos-reseaux/antennes-relais'
      },
      {
        title: "Installation d'une borne Free",
        items: [],
        link: '/fr/nos-reseaux/borne-free'
      },
      {
        title: 'Témoignages',
        items: [],
        link: '/fr/nos-reseaux/temoignages'
      }
    ]
  },
  {
    title: 'Médias',
    items: [
      {
        title: 'Communiqués de presse',
        items: [],
        link: '/fr/media/communiques-de-presse/all/all'
      },
      {
        title: 'Médiathèque',
        items: [],
        link: '/fr/media/mediatheque'
      }
    ]
  },
  {
    title: 'Investisseurs',
    items: [
      {
        title: 'Structure du groupe',
        items: [],
        link: '/fr/investisseurs/groupe/structure-du-groupe'
      },
      {
        title: 'Contact et agenda financier',
        items: [],
        link: '/fr/investisseurs/contact-et-agenda'
      },
      {
        title: 'Groupe iliad',
        items: [
          {
            title: 'Résultats financiers',
            items: [],
            link: '/fr/investisseurs/groupe/resultats/all/all'
          },
          {
            title: 'Communiqués financiers',
            items: [],
            link: '/fr/investisseurs/groupe/communiques-de-presse-financiers/all/all'
          },
          {
            title: 'Dette',
            items: [],
            link: '/fr/investisseurs/groupe/dette'
          },
          {
            title: 'Information réglementée',
            items: [],
            link: `/fr/investisseurs/groupe/information-reglementee/${new Date().getFullYear()}`
          },
          {
            title: 'Assemblée Générale',
            items: [],
            link: '/fr/investisseurs/groupe/assemblee-generale'
          },
          {
            title: 'Documents légaux',
            items: [],
            link: `/fr/investisseurs/groupe/documents-legaux/${new Date().getFullYear()}`
          }
        ],
        link: '/fr/investisseurs/contact-et-agenda',
        isSubMenu: true
      },
      {
        title: 'iliad Holding',
        items: [
          {
            title: 'Résultats financiers',
            items: [],
            link: '/fr/investisseurs/holding/resultats/all/all'
          },
          {
            title: 'Dette',
            items: [],
            link: '/fr/investisseurs/holding/dette'
          },
          {
            title: 'Communiqués de presse',
            items: [],
            link: '/fr/investisseurs/holding/communiques-de-presse-financiers/all/all'
          }
        ],
        link: '/fr/investisseurs/contact-et-agenda',
        isSubMenu: true
      }
    ]
  },
  {
    title: 'Carrières',
    items: [
      {
        title: 'Pourquoi nous rejoindre',
        items: [],
        link: '/fr/carrieres/pourquoi-nous-rejoindre'
      },
      {
        title: 'Métiers et entités',
        items: [],
        link: '/fr/carrieres/metiers'
      }
      /*,
            {
              title: 'Portail job étudiant',
              items: [],
              link: 'https://job-etudiant.iliad.fr',
              isExternalLink: true
            }*/
    ]
  }
]

const enItems: IMenuItem[] = [
  {
    title: 'About Us',
    items: [
      {
        title: 'The iliad revolution',
        items: [],
        link: '/en/le-groupe/la-revolution-iliad'
      },
      {
        title: 'Who we are',
        items: [],
        link: '/en/le-groupe/qui-sommes-nous'
      },
      {
        title: 'Our vision',
        items: [],
        link: '/en/le-groupe/vision'
      },
      {
        title: 'Our motto',
        items: [],
        link: '/en/le-groupe/devise'
      },
      {
        title: '25 years of innovation',
        items: [],
        link: '/en/le-groupe/25-ans-innovation'
      },
      {
        title: 'Governance',
        items: [],
        link: '/en/le-groupe/gouvernance'
      },
      {
        title: 'Ethics & Compliance',
        items: [],
        link: '/en/le-groupe/ethique-et-conformite'
      }
    ]
  },
  {
    title: 'Our Commitments',
    items: [
      {
        title: 'Doing things right',
        items: [],
        link: '/en/nos-engagements/faire-les-choses-bien'
      },
      {
        title: 'For our people',
        items: [],
        link: '/en/nos-engagements/pour-nos-collaborateurs'
      },
      {
        title: 'For the environment',
        items: [],
        link: '/en/nos-engagements/pour-l-environnement'
      },
      {
        title: 'For society',
        items: [],
        link: '/en/nos-engagements/pour-la-societe'
      },
      {
        title: 'ESG Publications',
        items: [],
        link: `/en/nos-engagements/documents-esg/${new Date().getFullYear()}`
      }
    ]
  },
  {
    title: 'Our Networks',
    items: [
      {
        title: 'Key figures',
        items: [],
        link: '/en/nos-reseaux/chiffres-cles'
      },
      {
        title: 'Our presence in France',
        items: [],
        link: '/en/nos-reseaux/presence-en-france'
      },
      {
        title: 'Antenna installation',
        items: [],
        link: '/en/nos-reseaux/antennes-relais'
      },
      {
        title: 'Free Simbox installation',
        items: [],
        link: '/en/nos-reseaux/borne-free'
      },
      {
        title: 'Testimonials',
        items: [],
        link: '/en/nos-reseaux/temoignages'
      }
    ]
  },
  {
    title: 'News & Media',
    items: [
      {
        title: 'News releases',
        items: [],
        link: '/en/media/communiques-de-presse/all/all'
      },
      {
        title: 'Media library',
        items: [],
        link: '/en/media/mediatheque'
      }
    ]
  },
  {
    title: 'Investor Center',
    items: [
      {
        title: 'Group structure',
        items: [],
        link: '/en/investisseurs/groupe/structure-du-groupe'
      },
      {
        title: 'Contact and calendar',
        items: [],
        link: '/en/investisseurs/contact-et-agenda'
      },
      {
        title: 'iliad group',
        items: [
          {
            title: 'Financial results',
            items: [],
            link: '/en/investisseurs/groupe/resultats/all/all'
          },
          {
            title: 'Financial news releases',
            items: [],
            link: '/en/investisseurs/groupe/communiques-de-presse-financiers/all/all'
          },
          {
            title: 'Debt',
            items: [],
            link: '/en/investisseurs/groupe/dette'
          },
          {
            title: 'Regulatory disclosures',
            items: [],
            link: `/en/investisseurs/groupe/information-reglementee/${new Date().getFullYear()}`
          },
          {
            title: 'Annual General Meeting',
            items: [],
            link: '/en/investisseurs/groupe/assemblee-generale'
          }
        ],
        link: '/en/investisseurs/contact-et-agenda',
        isSubMenu: true
      },
      {
        title: 'iliad Holding',
        items: [
          {
            title: 'Financial results',
            items: [],
            link: '/en/investisseurs/holding/resultats/all/all'
          },
          {
            title: 'Debt',
            items: [],
            link: '/en/investisseurs/holding/dette'
          },
          {
            title: 'Financial news releases',
            items: [],
            link: '/en/investisseurs/holding/communiques-de-presse-financiers/all/all'
          }
        ],
        link: '/en/investisseurs/contact-et-agenda',
        isSubMenu: true
      }
    ]
  },
  {
    title: 'Careers',
    items: [
      {
        title: 'Why join us?',
        items: [],
        link: '/en/carrieres/pourquoi-nous-rejoindre'
      },
      {
        title: 'Our jobs and entities',
        items: [],
        link: '/en/carrieres/metiers'
      }
      /*,
            {
              title: 'Student job',
              items: [],
              link: 'https://job-etudiant.iliad.fr',
              isExternalLink: true
            }*/
    ]
  }
]

let localizedMenu = Map<string, List<IMenuItem>>()
localizedMenu = localizedMenu.set('fr', List(frItems))
localizedMenu = localizedMenu.set('en', List(enItems))

export const main = localizedMenu
